/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

function focus(elementOrRef) {
  const element = elementOrRef.current || elementOrRef;
  if (element && element.focus && document.activeElement !== element) {
    element.focus();
  }
}

export { focus };
